import React, { useContext, useEffect } from "react";

import { useAuth } from "../services/AuthService";
import { Redirect, RouteComponentProps } from "react-router";
import { IonContent, IonToast } from "@ionic/react";

import { AppPage } from "../AppContent";
import { useLogger } from "../services/LogService";
import { AppContext } from "../state/AppContextProvider";

interface EndRedirectPageProps extends RouteComponentProps { }

const EndRedirect: React.FC<EndRedirectPageProps> = (props: EndRedirectPageProps) => {

  const { state } = useContext(AppContext);

  const console = useLogger("EndRedirect");

  const auth = useAuth();

  useEffect(() => {
    console.info("useEffect()");
    auth.endSessionCallback();
    setInterval(() => props.history.replace('/'), 2500)
    //window.location.reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!state.isConnected) {
    return (
      <Redirect to="/" />
    );
  } else {
    return (
      <AppPage>
        <IonContent>
          <IonToast
            isOpen={!state.isConnected}
            color="primary"
            position="top"
            message="Loading..."
            duration={-1}
          />
        </IonContent>
      </AppPage>
    );
  }
};

export default EndRedirect;
